module.exports = __webpack_public_path__ + "img/lightbulb.35c6c4f7.svg";